// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"17a631a5","396":"f0e39555","605":"5e970ae3"}[chunkId] + ".chunk.css";
};